import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CoopGaranziaFidiFormValidators } from './validators/coop-garanzia-fidi.form-validators';
import { CoopGaranziaFidiFormListeners } from './listeners/coop-garanzia-fidi.form-listeners';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopGaranziaFidiFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor(protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(undefined, undefined, datiIdentificativiService);
    }

    override get dependencyPaths(): Set<string> {
        return new Set([
            // Bilancio
            `${formPaths.bilancio}.my_ImportoPatrSecondoEs`,
            `${formPaths.bilancio}.my_CapSocSottoscrSecondoEs`,
        ]);
    }

    override initListener(): void {
        new CoopGaranziaFidiFormListeners(this._form, this.store).setListeners();
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_Bilancio: this.fb.group({
                        my_ImportoPatrSecondoEs: '',
                        my_CapSocSottoscrSecondoEs: '',
                    }),
                    my_SchedaCoopFidi: this.fb.group({
                        my_ScCoopFidiObbl: '',
                        my_CkQuotaSocFidi: '',
                        my_GroupFidi: '',
                        my_CkCoopFidiConforme: '',
                        my_ServiziAiSociFidi: '',
                        my_CkFidiCompetenzaPr: '',
                        my_CkFidiCompetenzaRg: '',
                        my_CkFidiCompetenzaNz: '',
                        my_CkFidiSchemaBilancioConforme: '',
                        my_CoopFidiNote: '',
                        my_CkCapSocPerFidi: '',
                        my_CkPatrNettoPerFidi: '',
                        my_CkQuotaSocPercFidi: '',
                        my_CkVersFondiGarFidi: '',
                        my_CkTipoBilFidi: '',
                        my_CkSoloGaranziaFidi: '',
                        my_VolAttFinanzFidi: '',
                        my_tipoVigilanzaFidi: '',
                        my_CkFidiSchemaBilVig: '',
                        my_CkFidiVolAttBanca: '',
                        my_CkFidiVolAttBancaDiscip: '',
                        my_NoteVolumeAttBanca: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopGaranziaFidiFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaCoopFidi}.my_ScCoopFidiObbl`);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScCoopFidiObbl);
    }
}
